var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesAgentsFilledV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.6944C1.99989 14.642 2.24228 13.6052 2.70637 12.673C3.17047 11.7408 3.84243 10.941 4.66463 10.3422C5.48683 9.7434 6.43474 9.36343 7.42707 9.23488C8.4194 9.10634 9.42655 9.23306 10.3621 9.60417",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.6944C1.99989 14.642 2.24228 13.6052 2.70637 12.673C3.17047 11.7408 3.84243 10.941 4.66463 10.3422C5.48683 9.7434 6.43474 9.36343 7.42707 9.23488C8.4194 9.10634 9.42655 9.23306 10.3621 9.60417C10.3621 9.60417 7.36778 11.4255 6.5 13.1582C6.03654 14.0836 6.18107 15.6944 6.18107 15.6944H2Z",
    stroke: "white",
    strokeWidth: 1.35292,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18416 9.18691C10.3181 9.18691 12.048 7.36596 12.048 5.1197C12.048 2.87344 10.3181 1.05249 8.18416 1.05249C6.05022 1.05249 4.32031 2.87344 4.32031 5.1197C4.32031 7.36596 6.05022 9.18691 8.18416 9.18691Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.35292,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53711 15.2671H3.32031L5.81348 12.9331L5.53711 15.2671Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.04211
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 11L15.3071 14.2929C14.9166 14.6834 14.2834 14.6834 13.8929 14.2929L12.1071 12.5071C11.7166 12.1166 11.0834 12.1166 10.6929 12.5071L9 14.2",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7782 12.9519L18.7235 10.7103L16.5 11",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesAgentsFilledV2);
export default __webpack_public_path__ + "static/media/salesAgentsFilledV2.33ce33d0b64ca6e2d31928a98c12a887.svg";
export { ForwardRef as ReactComponent };